// extracted by mini-css-extract-plugin
export default {"notificator":"Notificator_notificator__M6E7O","toast-container":"Notificator_toast-container__H49--","in-iframe":"Notificator_in-iframe__WaR0e"};